module.exports = __webpack_public_path__ + "img/Wlodek Gogloza.a9ae7d08.jpg";